import React, { useState } from 'react'
import { 
  FaPlay, 
  FaClock, 
  FaEye, 
  FaList,
  FaYoutube,
  FaQuestionCircle
} from 'react-icons/fa'
import { Card, Row, Col, Button } from 'react-bootstrap'
import './Tutorials.css'

// Datos de tutoriales (por ahora solo uno, pero fácil de expandir)
const tutorialsData = [
  {
    id: 1,
    title: "Tutorial de Uso del Sistema",
    description: "Aprende a utilizar todas las funcionalidades principales de la plataforma Alleanza",
    youtubeId: "y75GVeffBkQ",
    duration: "15:30",
    views: "1.2K",
    level: "Básico",
    thumbnail: "https://img.youtube.com/vi/y75GVeffBkQ/maxresdefault.jpg",
    available: true
  },
  // Futuros tutoriales pueden agregarse aquí
  // {
  //   id: 2,
  //   title: "Gestión Avanzada de Usuarios",
  //   description: "Aprende técnicas avanzadas para administrar usuarios",
  //   youtubeId: "VIDEO_ID_2",
  //   duration: "12:45",
  //   views: "856",
  //   level: "Intermedio",
  //   thumbnail: "https://img.youtube.com/vi/VIDEO_ID_2/maxresdefault.jpg",
  //   available: false
  // }
]

export default function Tutorials() {
  const [selectedTutorial, setSelectedTutorial] = useState(tutorialsData[0])

  const handleTutorialSelect = (tutorial) => {
    if (tutorial.available) {
      setSelectedTutorial(tutorial)
    }
  }

  const openInYouTube = () => {
    window.open(`https://www.youtube.com/watch?v=${selectedTutorial.youtubeId}`, '_blank')
  }

  return (
    <div className="tutorials-container">
      <div className="container">
        {/* Header */}
        <div className="tutorials-header">
          <div className="header-content">
            <div className="header-icon">
              <FaPlay />
            </div>
            <div className="header-text">
              <h1>Tutoriales</h1>
              <p>Aprende a utilizar el sistema con nuestros videos tutoriales paso a paso</p>
            </div>
          </div>
        </div>

        <Row className="tutorials-content">
          {/* Contenido Principal - Video */}
          <Col lg={8} md={12}>
            <Card className="main-video-card">
              <Card.Body className="video-container">
                <div className="video-wrapper">
                  <iframe
                    width="100%"
                    height="400"
                    src={`https://www.youtube.com/embed/${selectedTutorial.youtubeId}?si=RS3zdN-_3M7-W6rm`}
                    title={selectedTutorial.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
                
                <div className="video-actions">
                  <Button 
                    variant="outline-danger" 
                    className="youtube-btn"
                    onClick={openInYouTube}
                  >
                    <FaYoutube className="me-2" />
                    Ver en YouTube
                  </Button>
                </div>

                <div className="video-info">
                  <h3 className="video-title">{selectedTutorial.title}</h3>
                  <p className="video-description">{selectedTutorial.description}</p>
                  
                  <div className="video-metadata">
                    <div className="metadata-item">
                      <FaClock className="metadata-icon" />
                      <span>{selectedTutorial.duration}</span>
                    </div>
                    <div className="metadata-item">
                      <FaEye className="metadata-icon" />
                      <span>{selectedTutorial.views} visualizaciones</span>
                    </div>
                    <div className="metadata-badge">
                      <span className={`level-badge ${selectedTutorial.level.toLowerCase()}`}>
                        {selectedTutorial.level}
                      </span>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Sidebar - Lista de Tutoriales */}
          <Col lg={4} md={12}>
            <Card className="tutorials-sidebar">
              <Card.Header className="sidebar-header">
                <h4>
                  <FaList className="me-2" />
                  Tutoriales Disponibles
                </h4>
              </Card.Header>
              <Card.Body className="sidebar-content">
                {tutorialsData.map((tutorial) => (
                  <div 
                    key={tutorial.id}
                    className={`tutorial-item ${selectedTutorial.id === tutorial.id ? 'active' : ''} ${!tutorial.available ? 'disabled' : ''}`}
                    onClick={() => handleTutorialSelect(tutorial)}
                  >
                    <div className="tutorial-thumbnail">
                      <img 
                        src={tutorial.thumbnail} 
                        alt={tutorial.title}
                        className="thumbnail-img"
                      />
                      {!tutorial.available && (
                        <div className="coming-soon-overlay">
                          <FaPlay className="play-icon" />
                        </div>
                      )}
                    </div>
                    <div className="tutorial-details">
                      <h6 className="tutorial-item-title">{tutorial.title}</h6>
                      <div className="tutorial-meta">
                        <span className="duration">{tutorial.duration}</span>
                        <span className="views">{tutorial.views}</span>
                      </div>
                      {tutorial.available ? (
                        <span className="status-badge available">Disponible</span>
                      ) : (
                        <span className="status-badge coming-soon">Próximamente</span>
                      )}
                    </div>
                  </div>
                ))}

                {/* Sección de Próximos Tutoriales */}
                <div className="coming-soon-section">
                  <div className="coming-soon-content">
                    <FaPlay className="coming-soon-icon" />
                    <h6>Más Tutoriales Próximamente</h6>
                    <p>Estamos preparando más contenido educativo para ti</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Sección de Ayuda */}
        <Row className="mt-4">
          <Col>
            <Card className="help-section">
              <Card.Body className="help-content">
                <div className="help-icon">
                  <FaQuestionCircle />
                </div>
                <div className="help-text">
                  <h5>¿Necesitas Ayuda?</h5>
                  <p>Si tienes alguna pregunta o necesitas asistencia adicional, no dudes en contactarnos.</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
